import React, { createContext, useReducer, useContext } from "react";
import gridReducer, { initialState, actions } from "../reducers/gridReducer";

export const GridContext = createContext(initialState);

export const GridProvider = ({ children }) => {
    const [state, dispatch] = useReducer(gridReducer, initialState);

    //console.log('GridProvider', {gridReducer});
    //console.log('GridProvider', {initialState});
    //console.log('GridProvider', {state});
    //console.log('GridProvider', {dispatch});
    //console.log('GridProvider', {children});
    //console.log('GridProvider', {actions});

    const setProject = (project) => {
        dispatch({
            type: actions.SET_PROJECT,
            payload: {
                project: project
            }
        });
    }

    const setDispatchUnit = (dispatchUnit) => {
        dispatch({
            type: actions.SET_DISPATCH,
            payload: {
                dispatchUnit: dispatchUnit
            }
        });
    }

    const setStartDate = (startDate) => {
        dispatch({
            type: actions.SET_START,
            payload: {
                startDate: startDate
            }
        });
    }

    const setEndDate = (endDate) => {
        dispatch({
            type: actions.SET_END,
            payload: {
                endDate: endDate
            }
        });
    }

    const setTrimStartDate = (trimStartDate) => {
        dispatch({
            type: actions.SET_TRIM_START,
            payload: {
                trimStartDate: trimStartDate
            }
        });
    }

    const setTrimEndDate = (trimEndDate) => {
        dispatch({
            type: actions.SET_TRIM_END,
            payload: {
                trimEndDate: trimEndDate
            }
        });
    }

    const setShowArchivedDispatchUnits = (showArchivedDispatchUnits) => {
        dispatch({
            type: actions.SET_SHOW_ARCHIVED,
            payload: {
                showArchivedDispatchUnits: showArchivedDispatchUnits
            }
        });
    }

    const setDataLoaded = (dataLoaded) => {
        dispatch({
            type: actions.SET_DATA_LOADED,
            payload: {
                dataLoaded: dataLoaded
            }
        });
    }

    const value = {
        setProject,
        setDispatchUnit,
        setStartDate,
        setEndDate,
        setTrimStartDate,
        setTrimEndDate,
        setShowArchivedDispatchUnits,
        setDataLoaded,
        project: state.project,
        dispatchUnit: state.dispatchUnit,
        startDate: state.startDate,
        endDate: state.endDate,
        trimStartDate: state.trimStartDate,
        trimEndDate: state.trimEndDate,
        showArchivedDispatchUnits: state.showArchivedDispatchUnits,
        dataLoaded: state.dataLoaded,
    };
    return <GridContext.Provider value={value}>{children}</GridContext.Provider>;
}

const useGrid = () => {
    const context = useContext(GridContext);
  
    if (context === undefined) {
      throw new Error("useGrid must be used within GridProvider");
    }
  
    return context;
  };
  
  export default useGrid;